import { MaterialIcons } from '@expo/vector-icons';
import styled from 'styled-components/native';
import theme from '../../../global/styles/theme';

export const Container = styled.SafeAreaView<{appTheme: 'light' | 'dark'}>`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  background-color: ${({appTheme}) =>
    theme.colors(appTheme).backgroundColor};
  width: 100%;
  height: 100%;
`;

export const Column = styled.View``;

export const Body = styled.View`
  align-items: center;
  margin-top: 20px;
  flex: 1;
  width: 100%;
`;

export const ContainerArea = styled.View<{appTheme: 'light' | 'dark'}>`
  flex: 1;
  background-color: ${({appTheme}) =>
    theme.colors(appTheme).backgroundColor};
  width: 100%;
`;

export const Item = styled.View`
  width: 95%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  min-height: 50px;
  align-self: center;
`;

export const Row = styled.View`
  align-items: center;
  flex-direction: row;
  gap: 5px;
`;

export const ImageToken = styled.Image`
  height: 40px;
  width: 40px;
`;

export const IconImageMaterialIcons = styled(MaterialIcons)``;

export const HeaderList = styled.View`
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  width: 90%;
  max-width: 90%;
  flex-wrap: wrap;
  align-self: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;
